import { BxfLink, BxfTargetAtrEnum } from '@blk/bxf-react-components';
import { ChatFooterConstants } from '../constants';

const { LEARN_MORE_LINK } = ChatFooterConstants;

const ImportantInfoConstants = {
    iShareFundLabel: 'iShares Fund',
    blkFundLabel: 'BlackRock Fund',
    learnMoreLabel: 'click here',
    hereLinkLabel: 'here.',
    additionalProductDataLabel: 'additional products',
    smaDataLabel: 'separately managed accounts',
    blkProductsLink:
        'https://www.blackrock.com/us/financial-professionals/investments/products/investment-funds#/?productView=all&pageNumber=1&sortColumn=totalNetAssets&sortDirection=desc&dataView=perfNav',
    smaLink:
        'https://www.blackrock.com/us/financial-professionals/investments/products/managed-accounts',
    iShareLink:
        'https://www.blackrock.com/us/financial-professionals/investments/products/managed-accounts',
};

const {
    iShareFundLabel,
    iShareLink,
    blkFundLabel,
    learnMoreLabel,
    hereLinkLabel,
    additionalProductDataLabel,
    smaDataLabel,
    blkProductsLink,
    smaLink,
} = ImportantInfoConstants;

const ImportantInfoContent = (): JSX.Element => {
    return (
        <div slot='important-information' style={{ paddingBottom: '2rem' }}>
            <b>
                For ChatBLK methodology and additional notices, please&nbsp;
                <BxfLink
                    label={learnMoreLabel}
                    href={LEARN_MORE_LINK}
                    dataLinkEvent={`chatblk | disclaimer | link click | important info | ${learnMoreLabel}`}
                    target={BxfTargetAtrEnum.BLANK}
                ></BxfLink>
                <br />
                <br />
                ChatBLK is for financial professional use only.
                <br />
                <br />
                Carefully consider the Funds&apos; investment objectives, risk
                factors, and charges and expenses before investing. This and
                other information can be found in the Funds&apos; prospectuses
                or, if available, the summary prospectuses, which may be
                obtained by visiting the &nbsp;
                <BxfLink
                    label={iShareFundLabel}
                    href={iShareLink}
                    target={BxfTargetAtrEnum.BLANK}
                    dataLinkEvent={`chatblk | disclaimer | link click | important info | ${iShareFundLabel.toLowerCase()}`}
                ></BxfLink>
                &nbsp;and&nbsp;
                <BxfLink
                    label={blkFundLabel}
                    href={iShareLink}
                    target={BxfTargetAtrEnum.BLANK}
                    dataLinkEvent={`chatblk | disclaimer | link click | important info | ${blkFundLabel.toLowerCase()}`}
                ></BxfLink>
                &nbsp;prospectus pages. Read the prospectus carefully before
                investing.
                <br />
                <br />
                Any iShares Trusts or other products registered only under the
                Securities Act of 1933 referenced in this material are not
                investment companies, and therefore are not subject to the same
                regulatory requirements as mutual funds or ETFs registered under
                the Investment Company Act of 1940. Investments in these
                products may be speculative and involve a high degree of risk.
                This information must be preceded or accompanied by a current
                prospectus for these products. Investors should read and
                consider it carefully before investing.
            </b>
            <br />
            <br />
            <b>
                Investing involves risks, including possible loss of
                principal.&nbsp;
            </b>
            Asset allocation and diversification may not protect against market
            risk, loss of principal or volatility of returns.
            <br />
            <br />
            <b>Past performance does not guarantee future results.</b>
            <br />
            <br />
            Information regarding BlackRock separately managed accounts (SMAs)
            is available&nbsp;
            <BxfLink
                label={hereLinkLabel}
                href={smaLink}
                dataLinkEvent={`chatblk | disclaimer | link click | important info | ${smaDataLabel}`}
                target={BxfTargetAtrEnum.BLANK}
            ></BxfLink>
            <br />
            <br />
            Information regarding additional BlackRock products is
            available&nbsp;
            <BxfLink
                label={hereLinkLabel}
                href={blkProductsLink}
                dataLinkEvent={`chatblk | disclaimer | link click | important info | ${additionalProductDataLabel}`}
                target={BxfTargetAtrEnum.BLANK}
            ></BxfLink>
            <br />
            <br />
            Please note that information provided by the ChatBLK tool should not
            be relied upon as research, investment advice, or a recommendation
            regarding any products, strategies, or securities. This material is
            strictly for illustrative, educational, or informational purposes
            and is subject to change.
            <br />
            <br />
            This material contains general information only and does not take
            into account an individual&apos;s financial circumstances. This
            information should not be relied upon as a primary basis for an
            investment decision. Investors should consult with their financial
            professionals prior to making an investment decision.
            <br />
            <br />
            The products and any strategies discussed are strictly for
            illustrative and educational purposes and are not a recommendation,
            offer or solicitation to buy or sell any securities or to adopt any
            investment strategy. There is no guarantee that any product or
            strategy referenced will be effective.
            <br />
            <br />
            Any opinions expressed are subject to change. The information and
            opinions are derived from proprietary and nonproprietary sources
            deemed by BlackRock to be reliable, but are not guaranteed as to
            accuracy.
            <br />
            <br />
            The information provided does not constitute any specific legal, tax
            or accounting advice. Please consult with qualified professionals
            for these types of advice.
            <br />
            <br />
            The iShares and BlackRock Funds are distributed by BlackRock
            Investments, LLC.
            <br />
            <br />
            The BlackRock model portfolios are made available to financial
            professionals by BlackRock Fund Advisors (“BFA”) or BlackRock
            Investment Management, LLC (“BIM”), which are registered investment
            advisers, or by BlackRock Investments, LLC (“BRIL”), which is the
            distributor of the BlackRock and iShares funds within the BlackRock
            model portfolios. BFA, BIM and BRIL (collectively, “BlackRock”) are
            affiliates.
            <br />
            <br />
            The BlackRock model portfolios are provided for illustrative and
            educational purposes only. The BlackRock model portfolios do not
            constitute research, are not personalized investment advice or an
            investment recommendation from BlackRock to any client of a third
            party financial professional, and are intended for use only by a
            third party financial professional, with other information, as a
            resource to help build a portfolio or as an input in the development
            of investment advice for its own clients. The BlackRock model
            portfolios themselves are not funds.
            <br />
            <br />
            BlackRock intends to allocate all or a significant percentage of the
            BlackRock model portfolios to funds for which it and/or its
            affiliates serve as investment manager and/or are compensated for
            services provided to the funds (&quot;BlackRock Affiliated
            Funds&quot;). Clients will indirectly bear fund expenses relating to
            assets allocated to funds, including BlackRock Affiliated Funds.
            BlackRock has an incentive to (a) select BlackRock Affiliated Funds
            and (b) select BlackRock Affiliated Funds with higher fees over
            BlackRock Affiliated Funds with lower fees.
            <br />
            <br />
            This information is intended for use in the United States. This
            information is not a solicitation for or offering of any investment,
            product, or service to any person in any jurisdiction or country in
            which such solicitation or offering would be unlawful.
            <br />
            <br />
            ChatBLK, and any data used by ChatBLK, is provided on an
            &quot;as-is&quot; basis. BlackRock expressly disclaims all
            warranties, express or implied, statutory or otherwise with respect
            to ChatBLK (and any data used by ChatBLK and the results obtained
            from use of ChatBLK) including, without limitation, all warranties
            or merchantability, fitness for a particular purpose or use,
            accuracy, completeness, originality and/or non-infringement. In no
            event shall BlackRock have any liability for any claims, damages,
            obligations, liabilities or losses relating to ChatBLK including,
            without limitation, any liability for any direct, indirect, special,
            incidental, punitive and/or consequential damages (including loss of
            profits or principal).
            <br />
            <br />
            <b>
                ©2025 BlackRock, Inc. or its affiliates. All Rights Reserved.
                BLACKROCK, BLACKROCK SOLUTIONS, BUILD ON BLACKROCK, ALADDIN,
                iSHARES, iBONDS, FACTORSELECT, iTHINKING, iSHARES CONNECT, FUND
                FRENZY, LIFEPATH, SO WHAT DO I DO WITH MY MONEY, INVESTING FOR A
                NEW WORLD, BUILT FOR THESE TIMES,&nbsp;
            </b>
            the iShares Core Graphic, <b>CoRI</b> and the <b>CoRI</b> logo are
            trademarks of BlackRock, Inc. or its affiliates. All other
            trademarks are those of their respective owners.
        </div>
    );
};
export default ImportantInfoContent;
